import { ProcessedMessage, StatefulMessage } from './useProcessMessage'
import { DriveItem } from '@microsoft/microsoft-graph-types'
import { useQueue } from '../useQueue'
import { QueueStatus } from '../queue/queueTypes'

export type DocumentNotificationData = StatefulMessage<{
    messageId: string // The original service bus message ID.
    driveItem: DriveItem
}>

export type DocumentNotification = ProcessedMessage<DocumentNotificationData>

export default function useProcessDocumentNotification() {
    const queue = useQueue()

    return (notification: DocumentNotification) => {
        queue.transition(notification.data.state, QueueStatus.Finished, {
            messageId: notification.data.messageId,
            driveItem: notification.data.driveItem,
        })
    }
}
